import { Button, CircularProgress, Grid, makeStyles, Typography } from '@material-ui/core';
import { CrsSettings, User, UserRole } from '../../domain/domain';
import React, { useEffect, useState } from 'react';
import { ApplicationState } from '../../reducers';
import { compose } from "redux";
import { connect, useDispatch } from "react-redux";
import NotFound from '../../components/NotFound';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { getCrsSettings, saveCrsSettings } from '../../api/user';
import { UiActionType } from '../../reducers/ui.reducer';
import { Link } from 'react-router-dom';

type Props = {
    currentUser: User
}

const useStyles = makeStyles(_ => ({
    root: {
        marginTop: 20
    },
}));

const CrsSettingsPage : React.FC<Props> = ({currentUser}) => {
    const classes = useStyles();
    const [crsSettings, setCrsSettings] = useState<CrsSettings | undefined>(undefined);
    const [mode, setMode] = useState<"edit" | "view">("view");
    const dispatch = useDispatch();

    useEffect(() => {
        getCrsSettings().then(response => {
            setCrsSettings(response.data);
        }).catch(error => {
            console.error(error);
        })
    }, []);

    if (currentUser.userRole !== UserRole.ADMINISTRATOR) {
        return <NotFound />
    }  

    if (crsSettings === undefined) {
        return <CircularProgress />
    }

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container direction='column' alignContent='center' spacing={5} alignItems='center' className={classes.root}>
            <Grid item>
                <Link to='/admin'>Administrator Page</Link>
            </Grid>
                <Grid item>
                    <Typography variant='h3'>Last Published Date</Typography>
                </Grid>
                <Grid item>
                    <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        disabled={mode !== "edit"}
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        label="Select Date"
                        value={crsSettings.lastPublishedDate !== undefined ? crsSettings.lastPublishedDate : null}
                        onChange={(date: any) => {
                            setCrsSettings({...crsSettings, lastPublishedDate: date});
                        }}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </Grid>
                <Grid item>
                    <Grid container direction='row' spacing={1}>
                        {mode === "edit" &&
                            <Grid item>
                                <Button size='small' color='primary' variant='contained' onClick={() => {
                                    saveCrsSettings(crsSettings).then(response => {
                                        dispatch({type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Last Published Date updated", severity: "success"}})
                                    }).catch(error => {
                                        console.error(error);
                                    })
                                    setMode('view');
                                }}>Save</Button>
                            </Grid>
                        }
                        {mode === "edit" &&
                            <Grid item>
                                <Button size='small' color='secondary' variant='contained' onClick={() => {
                                    setMode('view');
                                }}>Cancel</Button>
                            </Grid>
                        }
                        {mode === "view" &&
                            <Grid item>
                                <Button size='small' color='primary' variant='contained' onClick={() => {
                                    setMode('edit');
                                }}>Modify</Button>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </MuiPickersUtilsProvider>
    )
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        currentUser: state.user.currentUser
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return { dispatch };
} 

export default compose<any>(
    connect(mapStateToProps, mapDispatchToProps)
)(CrsSettingsPage);